module.exports = __webpack_public_path__ + "img/V-R-6-unload-standup-shadow.c21b07f1.png";